import useAccordionContext from './use-accordion-context';

export { useAccordionContext };
